import * as React from 'react';
import { useRecoilValue } from 'recoil';
import { useIntl } from 'react-intl';
import { CmdToastButton } from '@commander-services/gui-components/build/components/CmdToast';
import dayjs from 'dayjs';
import * as VehiclesDataState from '../../store/recoil/vehiclesData';
import { IVehicleData } from '../Vehicles/types';
import ConfirmToaster from '../Forms/ConfirmToaster/ConfirmToaster';
import { GRAPH_LIMIT } from './GraphService';
import { IVehicleOnlinePanels, onlinePanelAtom } from '../OnlinePanel/OnlinePanelState';
import usePrevious from '../../hooks/usePrevious';

interface IProps {
  loadData: () => void;
  vehicleId: number;
  handleEndRideDateAndAddress?: (value: string) => void;
  pointsCount: number;
  isRideJustEnded?: () => void;
}

export default function RideJustEnded(props: IProps) {
  const { formatMessage: f } = useIntl();
  const onlinePanelData = useRecoilValue<IVehicleOnlinePanels>(onlinePanelAtom);
  const onlinePanel = onlinePanelData[Number(props.vehicleId)];

  const vehicleData = useRecoilValue<IVehicleData | null>(
    VehiclesDataState.vehicleDataByIdSelector(props.vehicleId)
  );
  const [isRideJustEnded, setIsRideJustEnded] = React.useState(false);
  const previousVehicleStatus = usePrevious(vehicleData?.status, { jsonParse: false });

  const handleSubmitToastr = () => {
    setIsRideJustEnded(false);
    props.loadData();
  };

  const handleConfirmCancel = () => {
    setIsRideJustEnded(false);
  };

  const buttons: CmdToastButton[] = [
    {
      title: f({
        id: 'waypoint.confirm.dialog.cancel',
      }),
      style: 'link',
      type: 'cancel',
      onClickCallback: handleConfirmCancel,
    },
    {
      title: f({
        id: 'graph.velocity.toastr.button.submit',
      }),
      style: 'solid',
      type: 'submit',
      onClickCallback: handleSubmitToastr,
    },
  ];

  React.useEffect(() => {
    if (
      vehicleData?.status &&
      previousVehicleStatus &&
      vehicleData?.status !== previousVehicleStatus
    ) {
      if (vehicleData?.status === 'STOP' && previousVehicleStatus === 'DRIVING') {
        if (props.pointsCount > GRAPH_LIMIT) {
          setIsRideJustEnded(true);
        }
        const position = `${onlinePanel.latitude}, ${onlinePanel.longitude}`;
        const endAddress = `${dayjs(onlinePanel.timestamp).format('DD.MM.YYYY HH:mm')} - ${
          onlinePanel.address || position
        }`;
        if (props.handleEndRideDateAndAddress) {
          props.handleEndRideDateAndAddress(endAddress);
        }
        if (props.isRideJustEnded) {
          props.isRideJustEnded();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleData?.status, previousVehicleStatus]);

  return isRideJustEnded ? (
    <ConfirmToaster
      id="toast"
      title={f({
        id: 'toastr.info',
      })}
      message={f({ id: 'graph.velocity.toastr.message' })}
      type="info"
      duration={null}
      onClose={handleConfirmCancel}
      buttons={buttons}
    />
  ) : null;
}
